import { ClassInfo, CurricularComponent } from '../../types/School';

export function formatClasses(classesArray: ClassInfo[]): Record<string, string[]> {
  const grouped: Record<string, string[]> = {};

  for (const turma of classesArray) {
    const segment = turma.segmentName?.trim();
    const grade = turma.gradeName?.trim();

    if (!segment || !grade) {
      continue;
    }

    const key = `${segment} - ${grade}`;

    const componentes =
      turma.curricularComponents?.map((comp: CurricularComponent) => comp.name) ??
      [];

    if (!grouped[key]) {
      grouped[key] = [];
    }

    grouped[key].push(...componentes);
  }

  for (const key in grouped) {
    grouped[key] = [...new Set(grouped[key])];
  }

  return grouped;
}
